module.exports = __webpack_public_path__ + "static/img/svip.6570de9b.png";